<template>
  <div class="flex-grow">
    <div class="mt-6 flex flex-col">
      <div class="w-full md:max-w-3xl md:mx-auto px-4">
        <h1 class="mb-4">
          AirFormTable Features
        </h1>
        <p>
          Here are some of our main features. If you have a precise need, please
          feel free to contact us, or even to
          <a href="https://notionforms.canny.io/feature-requests">leave a feature request</a>.
        </p>
        <div class="my-10">
          <text-input
            v-if="features.length > 4"
            :form="searchFeature"
            name="search"
            label="Search a feature"
            placeholder="Type feature term..."
          />
          <div
            v-if="features && features.length"
            class="grid max-w-3xl grid-cols-1 mx-auto text-center sm:text-left mt-8 sm:grid-cols-2 gap-y-8 gap-x-8 lg:gap-x-20"
          >
            <div
              v-for="(feature, index) in enrichedFeatures"
              :key="index"
              class="relative group"
            >
              <div
                class="overflow-hidden rounded-lg aspect-w-16 aspect-h-9 shadow-lg"
              >
                <img
                  class="object-cover w-full h-full transition-all duration-300 transform group-hover:scale-110"
                  :src="`/img/pages/features/${feature.image_url}`"
                  alt=""
                >
              </div>
              <p class="text-xl font-bold text-gray-900 mt-2">
                {{ feature.title }}
              </p>
              <p class="text-sm group-hover:underline">
                <NuxtLink
                  class="text-gray-500"
                  :to="{
                    params: { slug: feature.slug },
                    name: 'features-slug',
                  }"
                >
                  Read More
                </NuxtLink>
              </p>
              <NuxtLink
                :to="{ params: { slug: feature.slug }, name: 'features-slug' }"
                title=""
              >
                <span
                  class="absolute inset-0"
                  aria-hidden="true"
                />
              </NuxtLink>
            </div>
            <p>
              And much more!
              <NuxtLink :to="{ name: 'register' }">
                Try AirFormTable for free.
              </NuxtLink>
            </p>
          </div>
        </div>
      </div>
    </div>
    <airtable-forms-footer />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import Fuse from 'fuse.js'
import features from '~/data/features.json'

useAirtableFormsSeoMeta({
  title: 'Features',
  description:
    "Discover AirformTable's features. We have everything you need to build beautiful forms!",
})

defineRouteRules({
  swr: 3600,
})

const searchFeature = useForm({
  search: '',
})

const enrichedFeatures = computed(() => {
  const featuresList = features

  if (searchFeature.search === '' || searchFeature.search === null)
    return featuresList

  // Fuze search
  const fuzeOptions = {
    keys: ['title', 'slug', 'body'],
  }
  const fuse = new Fuse(featuresList, fuzeOptions)
  return fuse.search(searchFeature.search).map((res) => {
    return res.item
  })
})
</script>
